// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__DWItH","rounded":"IconButton_rounded__qpdF-","spinner":"IconButton_spinner__GucI6","ib-spin":"IconButton_ib-spin__dWVS2"};